import { render } from "./AcademySide.vue?vue&type=template&id=68a73a90"
import script from "./AcademySide.vue?vue&type=script&lang=js"
export * from "./AcademySide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__